module.exports = __webpack_public_path__ + "img/img2.4c25324f.svg";